/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Store_FrozenInputs */

const en_store_frozen = /** @type {(inputs: Store_FrozenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frozen`)
};

const de_store_frozen = /** @type {(inputs: Store_FrozenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiefkühl`)
};

/**
* | output |
* | --- |
* | "Frozen" |
*
* @param {Store_FrozenInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const store_frozen = /** @type {((inputs?: Store_FrozenInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Store_FrozenInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_store_frozen(inputs)
	return en_store_frozen(inputs)
});